import CloseIcon from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import Link from '@mui/material/Link'
import { Divider, useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import Hidden from '@mui/material/Hidden'

interface IProps {
  onBecomePartner(): void
  onWatchProducts(): void
  onDisable(): void
  onClose(): void
}

const WholesalePartnerNotification: React.FC<IProps> = ({ onBecomePartner, onWatchProducts, onDisable, onClose }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div className='text-black w-full text-center md:max-w-300'>
      <h3 className='text-capitalize font-semibold text-lg mb-5 md:mb-10 leading-normal'>
        {t('title.unlockWholesaleOpportunities', 'Unlock Wholesale Opportunities!')}
      </h3>
      <span className='absolute right-10 top-10'>
        <IconButton onClick={onClose} size='medium' title={t('close', 'Close')}>
          <CloseIcon fontSize='inherit' />
        </IconButton>
      </span>
      <Hidden smUp>
        <Divider sx={{ borderWidth: '1px' }} />
      </Hidden>
      <div className='px-10 py-5 md:px-0 md:py-0'>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className='text-base text-gray text-center mb-5 md:mb-10'>
              <Hidden smDown>
                <Trans i18nKey='description.becomeWholesalePartner'>
                  <p className='text-base leading-normal'>Are you ready to take your business to the next level? 🚀</p>
                  <p className='text-base leading-normal'>
                    Become a Partner and gain access to unbeatable wholesale prices that will give your profit margins a
                    delightful boost.
                  </p>
                  <p className='text-base leading-normal'>
                    Join our network of successful partners who are already reaping the benefits of partnering with us!
                  </p>
                </Trans>
              </Hidden>
              <Hidden smUp>
                <Trans i18nKey='description.becomeWholesalePartnerShort'>
                  <p className='text-13 leading-normal'>
                    Become a Partner and gain access to unbeatable wholesale prices that will give your profit margins a
                    delightful boost.
                  </p>
                </Trans>
              </Hidden>
            </div>
          </Grid>
          <Grid item xs={6} sm={12} className='text-right'>
            <Button
              type='button'
              size={smDown ? 'medium' : 'large'}
              variant='contained'
              color='primary'
              onClick={onBecomePartner}
              sx={{ borderRadius: smDown ? '5px' : '20px' }}
              fullWidth={!smDown}
            >
              {t('button.becomeAPartner', 'Become a partner')}
            </Button>
          </Grid>
          <Grid item xs={6} sm={12} className='text-left'>
            <Button
              type='button'
              size={smDown ? 'medium' : 'large'}
              variant='outlined'
              color='primary'
              onClick={onWatchProducts}
              sx={{ borderRadius: smDown ? '5px' : '20px' }}
              fullWidth={!smDown}
            >
              {t('button.watchProducts', 'Watch products')}
            </Button>
          </Grid>
        </Grid>
        <div className='mt-10'>
          <Link
            onClick={(e: React.SyntheticEvent | Event) => {
              e.preventDefault()
              onDisable()
            }}
            underline='always'
          >
            <span className='text-gray text-sm md:text-base'>
              {t("button.don'tShowItAgain", "Don't show it again")}
            </span>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default WholesalePartnerNotification
